var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.04435 6.41634H4.50269C4.15751 6.41634 3.87769 6.69616 3.87769 7.04134C3.87769 7.38652 4.15751 7.66634 4.50269 7.66634H19.5027C19.8479 7.66634 20.1277 7.38652 20.1277 7.04134C20.1277 6.69616 19.8479 6.41634 19.5027 6.41634H15.961V5.37467C15.961 4.78702 15.7248 4.21287 15.278 3.76607C14.8312 3.31927 14.257 3.08301 13.6694 3.08301H10.336C9.74837 3.08301 9.17421 3.31927 8.72741 3.76607C8.28061 4.21287 8.04435 4.78703 8.04435 5.37467V6.41634ZM9.61129 4.64995C9.83116 4.43009 10.0903 4.33301 10.336 4.33301H13.6694C13.915 4.33301 14.1742 4.43009 14.3941 4.64995C14.6139 4.86982 14.711 5.12899 14.711 5.37467V6.41634H9.29435V5.37467C9.29435 5.12898 9.39143 4.86982 9.61129 4.64995Z",
    fill: "#717070",
    stroke: "#717070",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3374 11.208V16.208",
    stroke: "#717070",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6709 11.208V16.208",
    stroke: "#717070",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.16943 9.29199L6.91943 18.792C7.00276 19.6253 7.66943 20.292 8.5861 20.292H15.5028C16.3361 20.292 17.0861 19.6253 17.1694 18.792L17.9194 9.29199",
    stroke: "#717070",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.05a661b3ad94a38a5fe1d3ba3b8ba3a2.svg";
export { ForwardRef as ReactComponent };